import React from 'react'
import { SMART_FILTERS } from 'common/categories'
import { WrapperOverlay } from 'ui/WrapperOverlay'
import PageBanner from 'ui/PageBanner'
import bannerImage from 'images/backgrounds/all_games_banner.png'
import Wrapper from 'ui/Wrapper'
import getTexts from 'utils/localization'
import styled from 'styled-components'
import { BREAKPOINTS } from 'themes/dk/breakpoints'
import COlORS from 'themes/dk/colors'
import HeadingWithBadge from 'ui/HeadingWithBadge'
import { useHistory } from 'react-router'
import { ROUTES } from '@/routers/routes'
import device from '../utils/mediaQueries'

const FlexWrapper = styled(Wrapper)`
    display: flex;
    overflow: auto;
    flex-direction: row;
    flex-wrap: wrap;
    max-width: 1390px;
    width: 100%;
    margin: 0 auto;
    padding: 30px;

    @media screen and ${device.xxl} {
        max-width: 1000px;
        padding: 0;
    }
    @media screen and ${device.xl} {
        max-width: 900px;
    }
`

export const StyledWrapper = styled(Wrapper)`
    margin-top: 20px;
    display: grid;
    gap: 1rem;
    grid-template-columns: repeat(4, 1fr);
    padding: 0;

    @media screen and (min-width: ${BREAKPOINTS.xs + 'px'}) {
        grid-template-columns: repeat(2, 1fr);
    }

    @media screen and (min-width: ${BREAKPOINTS.sm + 'px'}) {
        grid-template-columns: repeat(3, 1fr);
    }

    @media screen and (min-width: ${BREAKPOINTS.md + 'px'}) {
        grid-template-columns: repeat(4, 1fr);
    }

    @media screen and (min-width: ${BREAKPOINTS.lg + 'px'}) {
        grid-template-columns: repeat(4, 1fr);
    }

    @media screen and (min-width: ${BREAKPOINTS.xl + 'px'}) {
        grid-template-columns: repeat(4, 1fr);
    }
`

export const CategoryCard = styled.div`
    position: relative;
    box-shadow: 0 10px 10px -8px #000000;
    border-radius: 8px;
    transition: transform 300ms ease-in-out;
    cursor: pointer;

    &:hover {
        transform: scale(1.05);
    }
`

export const CategoryCardTitle = styled.div`
    position: absolute;
    width: 100%;
    color: ${COlORS.white};
    text-align: center;
    bottom: 16px;
    font-size: 16px;
    padding: 0 5px;
    box-sizing: border-box;

    @media screen and (min-width: ${BREAKPOINTS.md + 'px'}) {
        font-size: 20px;
        bottom: 32px;
    }
`

const CategoryCardThemeTitle = styled.div`
    top: 50%;
    transform: translateY(-50%);
    position: absolute;
    width: 100%;
    color: ${COlORS.white};
    text-align: center;
    font-size: 20px;
    padding: 0 5px;
    box-sizing: border-box;

    @media screen and (min-width: ${BREAKPOINTS.lg + 'px'}) {
        font-size: 32px;
    }
`

export const CategoryImage = styled.img`
    border-radius: 8px;
    width: 100%;
    height: auto;

    min-width: 166px;

    @media screen and (min-width: ${BREAKPOINTS.xl + 'px'}) {
        min-width: 250px;
    }
`

const CagegoriesPage = () => {
    const t = getTexts()
    const history = useHistory()

    const handleClick = (key = 'features', category) => {
        history.push(`${ROUTES.CATEGORY_DETAIL}?key=${key}&value=${category}`)
    }

    const getCategories = (category) =>
        SMART_FILTERS.filter((item) => item.category === category).sort(
            (a, b) => a.label.localeCompare(b.label)
        ) || []

    return (
        <WrapperOverlay overlayOffset={250} margin="0" padding="0 10px 10px">
            <PageBanner
                bgImageUrl={bannerImage}
                title={`${SMART_FILTERS.length} ${t.categories}`}
            />
            <FlexWrapper>
                <HeadingWithBadge size="x5" bold>
                    Funktioner
                </HeadingWithBadge>
                <StyledWrapper
                    padding="0"
                    width="100%"
                    style={{ paddingBottom: '100px' }}
                >
                    {getCategories('features').map((item, key) => (
                        <CategoryCard
                            key={key}
                            onClick={() => handleClick('features', item.name)}
                        >
                            <CategoryImage src={item.image} />
                            <CategoryCardTitle>{item.label}</CategoryCardTitle>
                        </CategoryCard>
                    ))}
                </StyledWrapper>

                <HeadingWithBadge size="x5" bold>
                    Temaer
                </HeadingWithBadge>
                <StyledWrapper padding="0" width="100%">
                    {getCategories('theme').map((item, key) => (
                        <CategoryCard
                            key={key}
                            onClick={() => handleClick('theme', item.name)}
                        >
                            <CategoryImage src={item.image} />
                            <CategoryCardThemeTitle>
                                {item.label}
                            </CategoryCardThemeTitle>
                        </CategoryCard>
                    ))}
                </StyledWrapper>
            </FlexWrapper>
        </WrapperOverlay>
    )
}

export default CagegoriesPage
